import { render } from "./cpt-g6-dom.vue?vue&type=template&id=5d8b9f47&scoped=true"
import script from "./cpt-g6-dom.vue?vue&type=script&lang=js"
export * from "./cpt-g6-dom.vue?vue&type=script&lang=js"

import "./cpt-g6-dom.vue?vue&type=style&index=0&id=5d8b9f47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8b9f47"]])

export default __exports__